"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuPosition = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var PositionedMenuContent_1 = require("./PositionedMenuContent");
var RenderChildrenInPortal_1 = require("../utils/RenderChildrenInPortal");
var Wrapper = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "gd-menuPosition-wrapper" }, children));
};
var PortalIfTopLevelMenu = function (_a) {
    var topLevelMenu = _a.topLevelMenu, children = _a.children, portalTarget = _a.portalTarget;
    return topLevelMenu ? (react_1.default.createElement(RenderChildrenInPortal_1.RenderChildrenInPortal, { targetElement: portalTarget }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
var MenuPosition = /** @class */ (function (_super) {
    tslib_1.__extends(MenuPosition, _super);
    function MenuPosition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            togglerElInitialized: false,
        };
        _this.togglerEl = null;
        _this.setTogglerEl = function (el) {
            _this.togglerEl = el;
            _this.setState({
                togglerElInitialized: true,
            });
        };
        return _this;
    }
    // React Measure is not used because it cannot detect the left/top coordinate
    // changes of absolute positioned blocks. This caused problems where left/top
    // positions from React Measure were outdated. To solve this we do the
    // measurements manually in PositionedMenuContent at the correct time.
    MenuPosition.prototype.render = function () {
        var _a = this.props, portalTarget = _a.portalTarget, topLevelMenu = _a.topLevelMenu, contentWrapper = _a.contentWrapper, toggler = _a.toggler, opened = _a.opened, alignment = _a.alignment, spacing = _a.spacing, offset = _a.offset, togglerWrapperClassName = _a.togglerWrapperClassName, children = _a.children;
        // Top level menu uses React portals to be rendered in body element (or
        // any element specified in targetElement prop). Any submenus are rendered
        // inside of previous menu, so they do not need any portals.
        var ContentWrapper = contentWrapper;
        var MaybeWrapper = topLevelMenu ? react_1.default.Fragment : Wrapper;
        return (react_1.default.createElement(MaybeWrapper, null,
            react_1.default.createElement("div", { className: topLevelMenu ? togglerWrapperClassName : undefined, ref: this.setTogglerEl }, toggler),
            react_1.default.createElement(PortalIfTopLevelMenu, { portalTarget: portalTarget, topLevelMenu: topLevelMenu }, opened && this.state.togglerElInitialized && (react_1.default.createElement(ContentWrapper, null,
                react_1.default.createElement(PositionedMenuContent_1.PositionedMenuContent, { alignment: alignment, spacing: spacing, offset: offset, topLevelMenu: topLevelMenu, togglerEl: this.togglerEl }, children))))));
    };
    MenuPosition.defaultProps = {
        contentWrapper: react_1.default.Fragment,
    };
    return MenuPosition;
}(react_1.default.Component));
exports.MenuPosition = MenuPosition;
//# sourceMappingURL=MenuPosition.js.map